import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { ArrowRight } from "lucide-react";
import FieldNoteCard from "@/components/field-notes/FieldNoteCard";
import LeafSignature from "@/components/heritage/LeafSignature";
import { FIELD_NOTES } from "@/lib/fieldNotes";

const FEATURED_SLUGS = [
  "the-rhythm-of-the-islands",
  "nevis-and-the-art-of-slowing-down",
  "village-roads-rum-shops-and-afternoon-rain",
];

const FieldNotesGateway = () => {
  const featured = FEATURED_SLUGS
    .map((slug) => FIELD_NOTES.find((n) => n.slug === slug))
    .filter((n): n is (typeof FIELD_NOTES)[number] => Boolean(n));

  return (
    <section className="py-24 md:py-32 bg-background relative overflow-hidden">
      <LeafSignature variant="watermark" position="top-left" size="lg" tone="light" />
      <LeafSignature variant="watermark" position="bottom-right" size="xl" tone="light" />
      <div className="relative container mx-auto px-6" style={{ maxWidth: "1400px" }}>
        <Reveal className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14 md:mb-16">
          <div className="max-w-2xl">
            <p className="font-sans text-[11px] tracking-[0.42em] uppercase text-accent mb-5">
              Field Notes
            </p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.5rem] text-foreground leading-[1.05] mb-6">
              Field Notes from St. Kitts &amp; Nevis
            </h2>
            <p className="font-serif italic text-foreground/75 text-lg md:text-xl leading-relaxed max-w-xl">
              Observations, rhythms and quiet moments from life across the
              islands.
            </p>
          </div>
          <Link
            to="/field-notes"
            className="group inline-flex items-center gap-3 font-sans text-[11px] tracking-[0.32em] uppercase text-foreground hover:text-accent transition-colors self-start lg:self-end"
          >
            Enter the Field Notes Archive
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-10 gap-y-16 md:gap-x-14 md:gap-y-20">
          {featured.map((note, i) => (
            <Reveal key={note.slug} delay={i * 100}>
              <FieldNoteCard note={note} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FieldNotesGateway;
